import styled from '@emotion/styled';
import { COLOR, FONT_SIZE, FONT_WEIGHT } from '@ordermentum/ui-constants';

export const Container = styled('div')`
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 1;
  justify-items: center;
  align-items: center;
  & > div:not(:first-child) {
    padding-top: 1rem;
  }
`;

export const ContentContainer = styled('div')`
  display: flex;
  flex-direction: column;
  justify-items: center;
  padding: 2rem;
  padding-top: 3rem;
  & > div:not(:first-child) {
    padding-top: 1rem;
  }
`;

export const Header = styled('div')`
  font-size: ${FONT_SIZE['2XL']};
  font-weight: ${FONT_WEIGHT.NORMAL};
  color: ${COLOR.ORANGE};
  text-align: center;
`;

export const TextContainer = styled('div')`
  a {
    color: ${COLOR.ORANGE};
    text-decoration: underline;
    cursor: pointer;
  }
`;

export const Text = styled('div')`
  font-size: ${FONT_SIZE.BASE};
  font-weight: ${FONT_WEIGHT.LIGHT};
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const Subtitle = styled('p')`
  text-align: center;
  color: ${COLOR.ORANGE};
  font-size: ${FONT_SIZE.LG};
`;

export const SignedInText = styled('p')`
  margin: 0.8rem;
  font-size: 0.8rem;
  position: absolute;
  right: 0;
  > a {
    color: ${COLOR.ORANGE};
    text-decoration: underline;
    cursor: pointer;
  }
`;
